import React from "react";
import "./ContactUs.css";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="contact-container">
      <section className="contact-header">
        <div className="left-block">
         
          <h2>Let’s Collaborate</h2>
          <p><strong>Get In Touch & Reach Us</strong></p>
          <p className="collab-text">
            We’re here to help you connect with the right opportunities and build strong professional relationships. Whether you're a candidate seeking guidance or a company in need of talent, let’s build something great together.
          </p>
        </div>

        <div className="map-block">
          <img
            src="https://tse2.mm.bing.net/th?id=OIP.TshywCZJLnB9yEtOvoHJtgHaEe&pid=Api&P=0&h=180"
            alt="world map"
            className="world-map"
          />
          <div className="map-pin belgium" title="Belgium" />
          <div className="map-pin canada" title="Canada" />
          <div className="map-pin usa" title="USA" />
          <div className="map-pin india" title="India" />
        </div>
      </section>

      <section className="contact-info">
        <div className="info-block">
          <p>Follow us</p>
          <div className="social-icons">
            <FaFacebookF />
            <FaTwitter />
            <FaInstagram />
            <FaLinkedinIn />
          </div>
        </div>

        <div className="info-block">
          <FaPhoneAlt className="icon" />
          <span>+91-6364856603</span>
        </div>

        <div className="info-block">
          <FaEnvelope className="icon" />
          <span>info@talenttrektechnologies.com</span>
        </div>
      </section>

      <section className="global-branches">
        <div className="branch-card">
          <h3>Belgium</h3>
          <p>
            <FaMapMarkerAlt className="icon" /> Talent Trek Technologies,<br />
            Avenue Des Anciens Combattants 31 Box: 03 Evere, 1140 Brussels, Belgium
          </p>
        </div>
        <div className="branch-card">
          <h3>Canada</h3>
          <p>
            <FaMapMarkerAlt className="icon" /> Talent Trek Technologies,<br />
            APT:504, 1444 Rue Mackay, Montreal H3G 2H9 Quebec, Canada<br />
            Contact: +1 (416) 452-6915
          </p>
        </div>
        <div className="branch-card">
          <h3>USA</h3>
          <p>
            <FaMapMarkerAlt className="icon" /> Talent Trek Technologies,<br />
            3010 W Yorkshire Dr, Phoenix, AZ 85027<br />
            Contact: +1 623 432-9982
          </p>
        </div>
        <div className="branch-card">
          <h3>India</h3>
          <p>
            <FaMapMarkerAlt className="icon" /> Talent Trek Technologies,<br />
            Ground Floor, Novel Office, Marathahalli, Bangalore, Karnataka - 560037
          </p>
        </div>
      </section>

      <section className="contact-form-section">
        <h2>Get in Touch</h2>
        <form className="contact-form">
          <div className="form-row">
            <input type="text" placeholder="First Name" />
            <input type="text" placeholder="Last Name" />
          </div>
          <input type="email" placeholder="Email Address" />
          <textarea placeholder="Message" rows="5" />
          <button type="submit">Get in touch</button>
        </form>
      </section>
    </div>
  );
};

export default ContactUs;